import { Link } from "@src/components/ui-kit";

interface ProjectItemProps {
  id: string;
  code: string;
  title: string;
}

export const ProjectItem = (props: ProjectItemProps) => {
  const { id, code, title } = props;

  return (
    <div className="flex flex-wrap">
      <Link href={{ pathname: "/projects/detail", query: { id } }} pr="3">
        {code}
      </Link>
      <p className="truncate">{title}</p>
    </div>
  );
};
